var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirectionsRun = function SvgDirectionsRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.25 22.75v-5.836l-2.504-2.394-1.039 4.592-6.419-1.304.304-1.49 4.8.99 1.735-8.83-2.377.959v3.314h-1.5V8.454l3.969-1.68q.76-.318 1.12-.42.36-.104.66-.103.46 0 .85.24.393.242.64.644l1 1.6q.639 1.031 1.752 1.735t2.509.761v1.5a6.8 6.8 0 0 1-2.948-.784q-1.424-.735-2.427-2.13l-.745 3.76 2.12 2.039v7.134zM12.193 4.807a1.78 1.78 0 0 1-.54-1.306q0-.768.54-1.307.54-.54 1.307-.54t1.306.54q.54.54.54 1.307t-.54 1.306-1.306.54a1.78 1.78 0 0 1-1.307-.54"
  })));
};
export default SvgDirectionsRun;